import React, { useState } from 'react';

const SummaryWidget = ({ resume, contactId, onRegenerate }) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  const handleRegenerate = async () => {
    if (!contactId) {
      setError("Veuillez d'abord enregistrer le contact");
      return;
    }

    setIsGenerating(true);
    setError(null);

    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
      const token = localStorage.getItem('token') || '';
      const response = await fetch(`${API_URL}/api/contacts/${contactId}/generate-summary`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        }
      });

      const data = await response.json();

      if (data.status === 'success') {
        // Le résumé est déjà sauvegardé côté backend, on notifie juste le parent
        onRegenerate(data.summary);
      } else {
        setError(data.summary || 'Erreur lors de la génération');
      }
    } catch (err) {
      setError('Erreur de connexion à l\'API');
      console.error('Error generating summary:', err);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div
      className="text-white rounded-xl shadow-lg p-6"
      style={{ background: 'linear-gradient(135deg, #7C3AED 0%, #4338CA 100%)' }}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <i className="bi bi-robot text-3xl"></i>
          <h3 className="text-sm font-bold uppercase tracking-wide">Résumé IA du Profil</h3>
        </div>
        <button
          onClick={handleRegenerate}
          disabled={isGenerating}
          className="px-3 py-1.5 bg-white/20 hover:bg-white/30 rounded-lg text-xs font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed"
          title="Régénérer avec l'IA"
        >
          {isGenerating ? (
            <>
              <i className="bi bi-arrow-clockwise animate-spin"></i> Génération...
            </>
          ) : (
            <>
              <i className="bi bi-stars"></i> Régénérer
            </>
          )}
        </button>
      </div>
      
      <div className="text-sm leading-relaxed">
        {error ? (
          <p className="text-red-300 italic">{error}</p>
        ) : (
          <p className="italic">{resume}</p>
        )}
      </div>

      {!contactId && (
        <div className="mt-3 p-2 bg-amber-500/20 rounded-lg text-xs text-amber-200">
          <i className="bi bi-lightbulb-fill mr-1"></i>Enregistrez d'abord le contact pour générer un résumé IA
        </div>
      )}
    </div>
  );
};

export default SummaryWidget;